module.exports = __webpack_public_path__ + "static/media/manual-screen-2.e70384f1.png";